const key = 'autopilot_customer_update_link';
const ttl = 30 * 60 * 1000;
const valid = (id) => typeof id === 'string' && /^apc_[a-zA-Z0-9_-]{1,146}$/.test(id);

export function parseCustomerUpdateLink(href) {
  try {
    const u = new URL(href);
    const id = u.hash.slice('#conversation-'.length);
    return u.searchParams.get('mode') === 'autopilot' &&
      u.searchParams.get('tab') === 'replies' &&
      u.hash.startsWith('#conversation-') &&
      valid(id)
      ? id
      : null;
  } catch {
    return null;
  }
}

// Keep only an opaque conversation ID across the existing login bounce. This
// never fetches a conversation; the authenticated account's normal list wins.
export function captureCustomerUpdateLink(href, storage, now = Date.now()) {
  try {
    const id = parseCustomerUpdateLink(href || window.location.href);
    if (id) (storage || window.sessionStorage).setItem(key, JSON.stringify({ id, at: now }));
  } catch {
    /* storage can be unavailable */
  }
}
export function customerUpdateLink(storage, now = Date.now()) {
  try {
    const current = parseCustomerUpdateLink(window.location.href);
    if (current) return current;
  } catch {
    /* node tests */
  }
  try {
    const value = JSON.parse((storage || window.sessionStorage).getItem(key) || 'null');
    return valid(value?.id) && Number.isFinite(value?.at) && now >= value.at && now - value.at < ttl
      ? value.id
      : null;
  } catch {
    return null;
  }
}
export function clearCustomerUpdateLink() {
  try {
    window.sessionStorage.removeItem(key);
  } catch {
    /* unavailable */
  }
  try {
    const u = new URL(window.location.href);
    if (parseCustomerUpdateLink(u.href)) {
      u.searchParams.delete('mode');
      u.searchParams.delete('tab');
      u.hash = '';
      window.history.replaceState(null, '', `${u.pathname}${u.search}`);
    }
  } catch {
    /* unavailable */
  }
}
